'use strict';

module.exports = require('./browser/algorithms.json');



//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/algos.js
// module id = O+gO
// module chunks = 3